import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const ReleasesPage = lazy(() => import('./ReleasesPage'));

export const releaseRoutes: RouteObject[] = [
  {
    path: 'releases',
    element: (
      <ProtectedRoute action="releases:view">
        <ReleasesPage />
      </ProtectedRoute>
    ),
  },
];
